// extracted by mini-css-extract-plugin
module.exports = {"main":"price_main__MFuaU"};